angular.module('autoremind.reports.contacts')
    .factory('contactsReportService', [
    '$rootScope', '$enhancedHttp', '$q', '$timeout',
    function ($rootScope, $enhancedHttp, $q, $timeout) {
        var service = {
            loadingIndicator: {
                refCount: 0,
                state: true
            },
            dataIsDefined: false,
            statisticsModel: {},
            patientsFilter: 'withAppointments',
            clearModel: function () {
                if (statisticsModel !== undefined) {
                    statisticsModel = {};
                }
            },
            getStatistics: function () {
                var self = this;
                var deferred = $q.defer();
                $enhancedHttp({
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json' },
                    //url: '/mock/contacts.reports',
                    url: '/servlets/patients/contactstats/?filter=' + this.patientsFilter,
                    disableErrorDialog: false,
                    retryBtn: true
                }, this.loadingIndicator)
                    .then(function (data) {
                    console.log('aaaaa', data);
                    $timeout(function () {
                        if (typeof data.stats === 'undefined') {
                            return;
                        }
                        angular.forEach(data.stats, function (value, key) {
                            this[key] = parseFloat(value);
                        }, self.statisticsModel);
                        self.dataIsDefined = true;
                        deferred.resolve();
                    });
                }, function (error) {
                    deferred.resolve();
                });
                return deferred.promise;
            }
        };
        $rootScope.$on('event:auth-logout', function () {
            if (statisticsModel !== undefined) { // Needed as throwing error
                service.clearModel();
            }
        });
        return service;
    }
]);
//# sourceMappingURL=contacts.service.js.map